import React, { useState } from "react";

type Option = {
  label: string;
  value: "google" | "amazon" | "youtube" | "rakuten" | "tiktok" | "bing" | "appstore" | "googleplay" | "chiebukuro";
};

type Props = {
  options: readonly Option[];
  value: "google" | "amazon" | "youtube" | "rakuten" | "tiktok" | "bing" | "appstore" | "googleplay" | "chiebukuro";
  onChange: (value: "google" | "amazon" | "youtube" | "rakuten" | "tiktok" | "bing" | "appstore" | "googleplay" | "chiebukuro") => void; 
};

export const Dropdown: React.FC<Props> = ({ options, value, onChange }) => {
  const [open, setOpen] = useState(false);

  const selected = options.find((o) => o.value === value);

  return (
    <div style={{ position: "relative", width: "130px" }}>
      {/* 選択中の要素 */}
      <button
        style={{
          width: "100%",
          padding: "8px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          background: "#fff",
          textAlign: "center",
          cursor: "pointer",
        }}
        onClick={() => setOpen(!open)}
      >
        {selected?.label || "選択してください"}
        <span style={{ float: "right" }}>▼</span>
      </button>

      {/* オプションリスト */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "110%",
            left: 0,
            width: "100%",
            border: "1px solid #ccc",
            borderRadius: "4px",
            background: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            zIndex: 10,
          }}
        >
          {options.map((option) => (
            <div
              key={option.value}
              style={{
                padding: "8px",
                cursor: "pointer",
                background: option.value === value ? "#eee" : "#fff",
                textAlign: "center", 
              }}
              onClick={() => {
                onChange(option.value);
                setOpen(false);
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
